module.exports = __webpack_public_path__ + "static/media/falcon-torch-carrying-case-5.c46ccac3.jpg";